import { Value } from '@sinclair/typebox/value';
import { AgentCapabilities } from './snapshot.js';
import { PublicAgentNonTimelineEvent, PublicAgentTimelineEvent } from './envelope.js';
import { InteractionRequestedMessage, InteractionResolvedMessage, InteractionResponseMessage } from './interactions.js';
export function isPublicAgentTimelineEvent(value) {
    return Value.Check(PublicAgentTimelineEvent, value);
}
export function isPublicAgentNonTimelineEvent(value) {
    return Value.Check(PublicAgentNonTimelineEvent, value);
}
export function isInteractionRequestedMessage(value) {
    return Value.Check(InteractionRequestedMessage, value);
}
export function isInteractionResolvedMessage(value) {
    return Value.Check(InteractionResolvedMessage, value);
}
export function isInteractionResponseMessage(value) {
    return Value.Check(InteractionResponseMessage, value);
}
export function isAgentCapabilities(value) {
    return Value.Check(AgentCapabilities, value);
}
//# sourceMappingURL=public-validation.js.map